import FinishScriptCard from "./FinishScriptCard";

export default FinishScriptCard;
